import { useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../api";

import { Modal } from "react-bootstrap";

import "bootstrap/js/dist/modal.js";

import ModalComponentN1 from "../../components/Modal/ModalComponentN1";
import Loading from "../../components/Loading";
import { useAuth } from "../../app/useAuth";

export default function SearchN1Table() {
    const auth = useAuth();
    const location = useLocation();
    const params = useParams();
    const [N1Data, setN1Data] = useState([]);
    const [loading, setLoading] = useState(true);

    const [show, setShow] = useState(false);
    const [dataModal, setDataModal] = useState("");

    const fetchN1Records = useCallback(() => {
        let searchAdvanced = false;
        const formData = new FormData();

        if (location?.search) {
            searchAdvanced = true;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.forEach((v, k) => {
                formData.append(`filter[${k}]`, v);
            });
        }

        const urlParamsData = new URLSearchParams(formData);
        const sendParam = searchAdvanced ? urlParamsData : `filter[search]=${params?.name}`;

        api.get(`/search/n1?${sendParam}`)
            .then((response) => {
                const data = response.data;
                setN1Data(data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [params?.name, location]);

    useEffect(() => {
        if (params?.name) {
            fetchN1Records();
        }
    }, [params, fetchN1Records]);

    if (loading) return <Loading />;

    return (
        <div className="container">
            {/* <div className="my-5"></div> */}
            <div className="h5 mb-4">Search : {params?.name}</div>

            <div className="table-responsive">
                <table className="table caption-top table-striped table-bordered">
                    <caption>Rice EST</caption>
                    <thead>
                        <tr>
                            <th scope="col" className="font-monospace">
                                Sequence Name
                            </th>
                            <th scope="col" className="font-monospace">
                                Sequence Description
                            </th>
                            <th scope="col" className="font-monospace">
                                Blast Top Hit Accession
                            </th>
                            <th scope="col" className="text-center">
                                {/* การดำเนินการ */}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {N1Data.length > 0 ? (
                            N1Data.map((item) => {
                                return (
                                    <tr key={item?.id}>
                                        <th scope="row" className="font-monospace">
                                            {item?.sequence_name}
                                        </th>
                                        <td className="font-monospace">{item?.sequence_description}</td>
                                        <td className="font-monospace">
                                            <div className="text-ellipsis text-max-width-200">{item?.blast_top_hit_accession}</div>
                                        </td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm text-nowrap"
                                                onClick={() => {
                                                    setShow(true);
                                                    setDataModal(item);
                                                }}
                                            >
                                                อ่านเพิ่มเติม
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td className="text-center" colSpan={4}>
                                    ไม่พบข้อมูลที่Search
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className="font-monospace">Sequence Name : {dataModal?.sequence_name}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalComponentN1 data={dataModal} />
                </Modal.Body>
            </Modal>

            <br />
            <br />
            <br />
        </div>
    );
}
